"use client";
import { jsx, Fragment, jsxs } from "react/jsx-runtime";
import "../../../foundation/iconography/ExtraIconsProvider.js";
import "../../../foundation/iconography/IconVariantProvider.js";
import "../../../foundation/iconography/icons.js";
import { Icon } from "../../../foundation/iconography/Icon.js";
import "../../../foundation/typography/index.js";
import "react";
import "classnames";
import "../../../foundation/logos/Logo.css.js";
import { atoms } from "@gnist/themes/atoms.css.js";
import { TextBelowInput } from "./TextBelowInput.js";
const ValidationText = ({ id, message, validationState, className, disabled }) => {
  return jsx(Fragment, { children: message ? jsxs(TextBelowInput, { id, "aria-live": "polite", "aria-atomic": "true", className, validity: validationState, isDisabled: disabled, children: [jsx(Icon, { icon: validationState, size: "s", className: atoms({ paddingRight: "base" }) }), message] }) : jsx(TextBelowInput, { isDisabled: disabled, children: " " }) });
};
export {
  ValidationText
};
